/**
 * Chunky inline-SVG icons for the pad buttons. They inherit the button's text
 * colour (currentColor) and are hidden from screen readers — every button
 * carries its own aria-label.
 */
export type HwIconName = 'check' | 'undo' | 'clear' | 'choices' | 'back' | 'redo' | 'skip' | 'next';

const PATHS: Record<HwIconName, string> = {
  check: 'M5 12.5l4.5 4.5L19 7.5',
  undo: 'M9 14L4 9l5-5M4 9h10a6 6 0 010 12h-3',
  clear: 'M6 6l12 12M18 6L6 18',
  choices: 'M4 5h7v6H4zM13 5h7v6h-7zM4 13h7v6H4zM13 13h7v6h-7z',
  back: 'M15 5l-7 7 7 7',
  redo: 'M20 12a8 8 0 11-2.3-5.7M20 4v5h-5',
  skip: 'M5 5l7 7-7 7M13 5l7 7-7 7',
  next: 'M9 5l7 7-7 7',
};

export function HwIcon({ name }: { name: HwIconName }) {
  return (
    <svg className="hw-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d={PATHS[name]} />
    </svg>
  );
}
